module.exports = "/_next/static/images/80d936e82beeec2b96a253d5eea1ddb8-girl-holding-phone@0.5x.jpg.webp";